import { Injectable } from '@angular/core';

import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService) {
  }

  showSuccess(message, title) {
    this.toastr.success(message, title)
  }

  showError(message: string, title: string, config?: Partial<IndividualConfig>) {
    this.toastr.error(message, title, config)
  }

  showInfo(message, title) {
    this.toastr.info(message, title)
  }

  showWarning(message, title) {
    this.toastr.warning(message, title)
  }

}